<header>
  <img src="images/kinomap-screen-logo.svg" alt="le logo de kinomap" />
</header>
<section>
  <ng-content />
</section>
<footer>
  <div class="get-app">
    <a [href]="kinomapUrl">
      <img class="kinomap-icon" src="images/kinomap-black.svg" alt="le logo de kinomap" />
    </a>
    <ul>
      <li>
        <a [href]="kinomapAppstoreUrl">
          <img src="images/app-store.svg" alt="le logo de l'app store apple" />
        </a>
      </li>
      <li>
        <a [href]="kinomapPlaystoreUrl">
          <img src="images/play-store.svg" alt="le logo du play store android" />
        </a>
      </li>
    </ul>
  </div>
  <ng-content select="app-connection-code" />
</footer>
